import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './bookContents.index.less';
import { getAllBookContents, BookContent } from '../../services/bookService';

const BookContents: React.FC = () => {
  const navigate = useNavigate();
  const [contents, setContents] = useState<BookContent[]>([]);

  useEffect(() => {
    const fetchBookContents = async () => {
      const fetchedContents = await getAllBookContents();
      setContents(fetchedContents);
    };

    fetchBookContents();
  }, []);

  const handleContentClick = (id: number) => {
    navigate(`/book/${id}`);
  };

  return (
    <div className="book-contents-container">
      <h2 className="book-name">Table Of Contents</h2>
      <ul className="book-contents-list">
        {contents.map(item => (
          <li key={item.id} className="book-contents-list-item" onClick={() => handleContentClick(item.id)}>
            <span className="list-item-title">{item.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BookContents;
